import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isOperatorMcpConnection = objectOf({
  id: string,
  name: string,
  display_name: string,
  server_url: string,
  client_id: anyOf(string, nullOrUndefined),
  has_client_secret: boolean,
  created_at: string,
  connected: boolean,
});

export const isGetAppGroupIdOperatorMcpConnectionsResult = objectOf({
  connections: arrayOf(isOperatorMcpConnection),
});
